'use client';
import * as React from "react";
import { useButton_unstable } from "@fluentui/react-button";
import { Navigation20Filled } from "@fluentui/react-icons";
/**
 * Given user props, defines default props for the Button, calls useButtonState and useChecked, and returns
 * processed state.
 * @param props - User provided props to the Button component.
 * @param ref - User provided ref to be passed to the Button component.
 */ export const useHamburger_unstable = (props, ref)=>{
    return useButton_unstable({
        icon: /*#__PURE__*/ React.createElement(Navigation20Filled, null),
        appearance: 'transparent',
        ...props
    }, ref);
};
